import {
    baseInitialState, BaseNotificationsState
} from './base-notification/base-notification.state';

export interface DocumentNotificationsState {
    certifications: BaseNotificationsState;
    publicHealthRecords: BaseNotificationsState;
}

export const initialState: DocumentNotificationsState = {
    certifications: baseInitialState,
    publicHealthRecords: baseInitialState
};
